module.exports = __webpack_public_path__ + "images/b574a43937098e5c2a8d09e4ab10bdc6a8df20f9c4f1e793f8a30f0a4f68e41c.svg";